// eslint-disable-next-line import/prefer-default-export
export const productUrl = route => {
  if (route?.startsWith('/furniture/product')) return route
  return `/furniture/product${route}`
}

const productListUrlMatcher = `/furniture/`
const productDetailsUrlMatcher = `/furniture/product/`

export const isRoutePLP = route =>
  !!route && route.startsWith(productListUrlMatcher) && !route.startsWith(productDetailsUrlMatcher)

export const isRoutePDP = route => !!route && route.includes(productDetailsUrlMatcher)

export const getFullRoute = route =>
  `${typeof window !== 'undefined' ? window.location.origin : 'https://www.roomstogo.com'}${
    route[0] !== '/' ? '/' : ''
  }${route}`
